/**
 * El nombre de la marca en la consola, en un solo lugar: QuadRoam (D-144, D-173, D-180).
 *
 * El backend tiene la misma constante en `qrcl/core/branding.py`, y `tests/unit/qrcl/test_marca_unica.py`
 * exige que las dos digan lo mismo y que el nombre anterior no aparezca en el código. Cambiar la marca es
 * cambiar esta línea y la del backend, en un PR.
 */
export const BRAND = 'QuadRoam';
